import isEmpty from 'lodash/isEmpty'
import * as React from 'react'
import * as RasaInput from '../../../components/rasa-input'
import * as CommunityConfig from '../../community-config'
import * as Constants from './constants'
import * as Types from './types'

interface ComponentProps { updateField: any }
interface StateProps {
  partnerCodes: CommunityConfig.PartnerCodesState
  form: Types.FormState
}
type Props = StateProps & ComponentProps

export const PartnerCode = ({partnerCodes, form, updateField}: Props) =>
  <div>
    {!isEmpty(partnerCodes) &&
      <div className="field field-wrapper">
        <RasaInput.RasaSelectInput label="Partner Code"
                                   onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                    updateField({
                                       name: Constants.FieldNames.CommunityPartnerCode, value: e.target.value })}
                                   value={form.fields[Constants.FieldNames.CommunityPartnerCode] || ''}
                                   options={CommunityConfig.partnerCodesAsDropdownOptions(partnerCodes)}>
        </RasaInput.RasaSelectInput>
        </div>}
  </div>



// WEBPACK FOOTER //
// ./src/pages/lead-text/add-edit-modal/partner-code.tsx